import React, { Component } from 'react'
import { Card, Input, Button } from 'semantic-ui-react';
import { Editor } from '@tinymce/tinymce-react';
import { withOktaAuth } from '@okta/okta-react';
import { epochToDateString } from '../EpochToString';

import api from '../../apis/api'
import { SuccessToast, ErrorToast } from '../Toasters';
import UpdateEditor from './UpdateEditor'
import { ViewOnly } from '../TinyEditorConfig';


export default withOktaAuth(class UpdateFeed extends Component {

    constructor(props){
        super(props);
        this.state = {
            updateNote: "",
            updateNumber: "",
            selectedId: null,
            selectedNumber: ""
        }
    }

    onUpdate = (updateNote) => {
        if (updateNote === "") {
            ErrorToast('Please add a note')
            return
        }
        if (this.state.selectedNumber === "") {
            ErrorToast('Please add update number')
            return
        }
        api.put('/portalupdates', { id: this.state.selectedId, note: updateNote, updateNumber: this.state.selectedNumber })
            .then(r => {
                this.props.getPortalUpdates()
                this.setState({ selectedId: null, selectedNumber:"" })
                SuccessToast('Release Note Submitted', 'Portal release note has been submitted')
            })
            .catch(err => {
                ErrorToast(err)
            })
    }

    onDelete = (id) => {
        if (window.confirm("You sure you want to delete?")) {
            api.delete('/portalupdates', { params: { id: id } }).then(r => {
                this.props.getPortalUpdates()
            }).catch(err => ErrorToast(err))
        }
    }
    componentDidMount() {
        this._isUpdated = false
    }
    render() {
        return (this.props.portalUpdates.map(update => (
            <Card fluid key={update.id}>
                <Card.Content>
                    <Card.Header>
                        Update: {update.id === this.state.selectedId ? <Input type="text" placeholder="Update Number" name="updateNumber" value={this.state.selectedNumber} onChange={(e, d) => this.setState({ selectedNumber: d.value })} required /> : update.updateNumber}
                        <Button floated="right" inverted color='red' icon="trash" onClick={() => this.onDelete(update.id)} />
                        <Button floated='right' inverted color='orange' icon="edit" onClick={() => { this.setState({ selectedId: update.id, selectedNumber: update.updateNumber }) }} />
                    </Card.Header>
                    <Card.Meta>Released on {epochToDateString(update.submitdate)}</Card.Meta>
                    <Card.Description>
                        {update.id === this.state.selectedId?
                            <UpdateEditor data={update.note} callback={this.onUpdate} />
                            :
                            <Editor init={ViewOnly} value={update.note} />
                        }
                    </Card.Description>
                </Card.Content>
            </Card>
        )))
    }


})

